@if (userDetailView) {
<div class="col th-p chats group-details">
  <header class="top-box-shadow">
    <div class="chats" style="width: 100%">
      <div class="content-wrapper is-clearfix">
        <div class="chat-name">
          <figure class="has-text-centered">
            <i
              class="fa hideMobileView is-pulled-left"
              [ngClass]="{
                'fa-angle-double-left': !this.userComponent.viewSecondPanel,
                'fa-angle-double-right': this.userComponent.viewSecondPanel
              }"
              (click)="hideSecondPanel()"
            ></i>
          </figure>
          <div class="is-pulled-left">
            @if (!updatedUserDetail.user_icon) {
            <empty-uname
              [userName]="updatedUserDetail.first_name"
              [detailHeadProfile]="true"
            ></empty-uname>
            } @if (updatedUserDetail.user_icon) {
            <img
              [src]="profileUrl + updatedUserDetail.user_icon"
              class="is-pulled-left"
            />
            }
            <span class="chat-title-name hideMobileView is-size-6 mar-5-0">{{
              updatedUserDetail.first_name
            }}</span>
          </div>
          <div class="is-marginless is-clearfix is-pulled-right">
            @if (hideUserPwdPanel) {
            <div class="is-pulled-right userandgroupDetails">
              @if (acc_active) {
              <a
                class="button is-small userDesktopView"
                (click)="activateAndDeactiveUser()"
              >
                <i class="fa fa-ban has-text-danger" aria-hidden="true"></i>
                Deactive User
              </a>
              } @if (!acc_active) {
              <a
                class="button is-small userDesktopView"
                (click)="activateAndDeactiveUser()"
              >
                <i class="fa fa-check has-text-success" aria-hidden="true"></i>
                Active User
              </a>
              }
              <a
                class="button is-small userDesktopView"
                (click)="removeUserDetail()"
              >
                <i class="fa fa-trash-o" aria-hidden="true"></i> Delete User
              </a>
              @if (isEmailVerfied) {
              <a
                class="button is-small userDesktopView"
                (click)="openUserAccountPanel()"
              >
                <i
                  class="fa fa-lock"
                  aria-hidden="true"
                  style="font-size: 20px !important"
                ></i>
                Change Password
              </a>
              } @if (acc_active) {
              <a
                class="button is-small userMobileView"
                (click)="activateAndDeactiveUser()"
              >
                <i class="fa fa-ban has-text-danger" aria-hidden="true"></i>
              </a>
              } @if (!acc_active) {
              <a
                class="button is-small userMobileView"
                (click)="activateAndDeactiveUser()"
              >
                <i class="fa fa-check has-text-success" aria-hidden="true"></i>
              </a>
              }
              <a
                class="button is-small userMobileView"
                (click)="removeUserDetail()"
              >
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </a>
              <a
                class="button is-small userMobileView"
                (click)="openUserAccountPanel()"
              >
                <i
                  class="fa fa-lock"
                  aria-hidden="true"
                  style="font-size: 20px !important"
                ></i>
              </a>
              <a
                class="button is-small userMobileView"
                [routerLink]="['/userandgroup/user']"
                (click)="showUserHeadPanel()"
              >
                <i class="fa fa-close" style="font-size: 20px !important"></i>
              </a>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="contents is-marginless">
    <div class="chats scroll-bar">
      <div>
        <div class="column">
          <div class="columns is-clearfix">
            <div class="column is-9 is-offset-1">
              <div class="columns new-chat">
                <!-- <div class="columns new-chat mar-top15"> -->
                <div class="column">
                  <div class="card">
                    <div class="card-content">
                      <div class="content form-style">
                        @if (hideUserPwdPanel) {
                        <form
                          [formGroup]="newUserForm"
                          novalidate
                          [ngClass]="{ disabledForm: acc_active === false }"
                        >
                          <h3>User Details</h3>
                          <div class="columns">
                            <div class="column">
                              <div class="field">
                                <div class="control profile-img">
                                  @if (!updatedUserDetail.user_icon) {
                                  <empty-uname
                                    [userName]="updatedUserDetail.first_name"
                                    [detailProfile]="true"
                                  ></empty-uname>
                                  } @if (updatedUserDetail.user_icon) {
                                  <img
                                    [src]="
                                      profileUrl + updatedUserDetail.user_icon
                                    "
                                  />
                                  } @if (acc_active) {
                                  <span class="img-options">
                                    <div class="dropdown is-hoverable">
                                      <div class="dropdown-trigger">
                                        <i class="fa fa-camera"></i>
                                      </div>
                                      <div
                                        class="dropdown-menu"
                                        id="dropdown-menu4"
                                        role="menu"
                                      >
                                        <div class="dropdown-content">
                                          <a class="dropdown-item">
                                            <label class="file-label">
                                              <input
                                                class="file-input"
                                                name="profile"
                                                id="profile"
                                                type="file"
                                                (change)="onFileChange($event)"
                                                [disabled]="
                                                  selectedFileList.length > 0
                                                "
                                                #fileInput
                                                accept=".jpg, .jpeg,"
                                              />
                                              <span class="file-label"
                                                >Add Picture</span
                                              >
                                            </label>
                                          </a>
                                          @if
                                          (updatedUserDetail.user_icon!=null) {
                                          <a
                                            class="dropdown-item"
                                            (click)="deleteUserProfile()"
                                            >Remove Picture</a
                                          >
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >First Name
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="first_name"
                                    (keydown)="keyDownHandler($event)"
                                    autofocus
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.first_name"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Last Name
                                  <span class="required">*</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="last_name"
                                    (keydown)="keyDownHandler($event)"
                                    autofocus
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.last_name"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Roll Number</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="roll_number"
                                    (keydown)="keyDownHandler($event)"
                                    #inputEl
                                  />
                                  <!-- <form-validation [control]="newUserForm.controls.roll_number"></form-validation> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Role
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <div class="select is-fullwidth">
                                    <select formControlName="user_role">
                                      <option value>-- select --</option>
                                      @for (role of roleList; track role) {
                                      <option
                                        value="{{ role.role_id }}"
                                        [selected]="role.role_id == user_role"
                                      >
                                        {{ role.role_name }}
                                      </option>
                                      }
                                    </select>
                                    <form-validation
                                      [control]="newUserForm.controls.user_role"
                                    ></form-validation>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Contact Number
                                  <span class="required"> *</span>
                                </label>
                                <div class="control has-icons-left">
                                  <input
                                    type="text"
                                    class="input"
                                    name="phone"
                                    placeholder="Enter contact number"
                                    formControlName="phone_no"
                                    ng2TelInput
                                    [ng2TelInputOptions]="{
                                      initialCountry: 'us'
                                    }"
                                    (hasError)="hasError($event)"
                                    (ng2TelOutput)="getPhoneNumber($event)"
                                    (intlTelInputObject)="
                                      telInputObject($event)
                                    "
                                    (countryChange)="onCountryChange($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.phone_no"
                                  ></form-validation>
                                </div>
                                <!-- <div class="control">
                                      <input class="input" type="text" placeholder="" inputFocus formControlName="phone_no" (keydown)="keyDownHandler($event)">
                                      <form-validation [control]="newUserForm.controls.phone_no"></form-validation>
                                    </div> -->
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Registration Number</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="reg_number"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <!-- <form-validation [control]="newUserForm.controls.r"></form-validation> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Email
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="Email"
                                    placeholder=""
                                    inputFocus
                                    formControlName="email_id"
                                    [readonly]="true"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.email_id"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Address</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="user_address"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Last four SSN</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="aadhar_number"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="
                                      newUserForm.controls.aadhar_number
                                    "
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div formGroupName="user_residential"> -->
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">City</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="user_city"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">State</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="user_state"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Tax Id</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="pan_number"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <!-- <form-validation [control]="newUserForm.controls.r"></form-validation> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Zip</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="user_zip"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.user_zip"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">User Id</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    inputFocus
                                    formControlName="emis_number"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.emis_number"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Other IDs</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    inputFocus
                                    placeholder=""
                                    inputFocus
                                    formControlName="other_ids"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <!-- <form-validation [control]="newUserForm.controls.r"></form-validation> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- </div> -->
                          <!-- <div class="columns">
                            <div class="column">
                              <div class="field">
                                <div class="label">
                                  <label class="label">Gender
                                    <span class="required"> *</span>
                                  </label>
                                </div>
                                <div class="field-body">
                                  <div class="field is-narrow">
                                    <div class="control">
                                      <label class="radio" *ngFor="let g of genderArrayList; let i=index">
                                        <input  type="radio" name="gender" [checked]="g.value" formControlName="gender" value="{{g.value}}"> {{g.name}}
                                      </label>
                                    </div>
                                    <form-validation [control]="newUserForm.controls.gender"></form-validation>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <div class="columns">
                            <div class="column">
                              <div class="field">
                                <label class="label">Notes</label>
                                <div class="control">
                                  <textarea
                                    class="textarea"
                                    placeholder=""
                                    inputFocus
                                    formControlName="user_notes"
                                    rows="1"
                                    (keydown)="keyDownHandler($event)"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns display-flex">
                            @if (acc_active) {
                            <div class="column is-12 has-text-right is-small">
                              <button
                                type="button "
                                [routerLink]="['/userandgroup/user']"
                                (click)="showUserHeadPanel()"
                                class="button mar-0-10 is-small"
                              >
                                Cancel
                              </button>
                              <button
                                class="button is-link is-small"
                                [disabled]="
                                  (newUserForm.valid && !newUserForm.dirty) ||
                                  newUserForm.invalid
                                "
                                (click)="updateUserDetail(newUserForm.value)"
                              >
                                Update
                              </button>
                            </div>
                            }
                          </div>
                        </form>
                        }
                        <!-- User password update form -->
                        @if (!hideUserPwdPanel) {
                        <form [formGroup]="accountForm" novalidate>
                          <h3>User Account</h3>
                          <div class="content">
                            <div class="field is-horizontal">
                              <div class="field-label is-normal">
                                <label class="label">New Password</label>
                              </div>
                              <div class="field-body">
                                <div class="field">
                                  <div class="control">
                                    <input
                                      class="input"
                                      type="password"
                                      placeholder="New Password"
                                      formControlName="new_password"
                                    />
                                    <form-validation
                                      [control]="
                                        accountForm.controls.new_password
                                      "
                                    ></form-validation>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="field is-horizontal">
                              <div class="field-label is-normal">
                                <label class="label">Confirm Password</label>
                              </div>
                              <div class="field-body">
                                <div class="field">
                                  <div class="control">
                                    <input
                                      class="input"
                                      type="password"
                                      placeholder="Confirm Password"
                                      formControlName="confirm_password"
                                    />
                                    <form-validation
                                      [control]="
                                        accountForm.controls.confirm_password
                                      "
                                    ></form-validation>
                                  </div>
                                </div>
                              </div>
                            </div>
                            @if (submitted && accountForm.value.new_password !=
                            accountForm.value.confirm_password) {
                            <div>
                              <p class="help is-danger">
                                The Password doesn't match
                              </p>
                            </div>
                            }
                            <hr />
                            <div class="columns">
                              <div class="column has-text-right">
                                <button
                                  type="button"
                                  (click)="closeUserAccountPanel()"
                                  class="button mar-0-10"
                                >
                                  Cancel
                                </button>
                                <button
                                  class="button is-link"
                                  [disabled]="!accountForm.valid"
                                  (click)="
                                    updateAccountPassword(accountForm.value)
                                  "
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Group list modal -->
<div class="modal" [ngClass]="{ 'is-active': toggleModalSection }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">Select Groups</p>
    </div>
    <section class="modal-card-body">
      <div class="content">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="panel-block">
                <p class="control has-icons-left">
                  <input
                    class="input is-small"
                    type="text"
                    placeholder="search"
                    [(ngModel)]="searchText"
                    (keyup.enter)="groupSearchAndPagination(0)"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-search"></i>
                  </span>
                </p>
              </div>
              <div
                class="panel panel-overflow scroll-bar"
                infinite-scroll
                [infiniteScrollDistance]="modalScrollDistance"
                [infiniteScrollThrottle]="modalScrollThrottle"
                [scrollWindow]="false"
                (scrolled)="onScrollDown()"
              >
                @for (group of groupList; track group; let ind = $index) {
                <label
                  class="panel-block pos-relative"
                  [ngClass]="{
                    'is-warning':
                      group.is_aleady_selected && !group.is_selected,
                    'active-bg': !group.is_aleady_selected && group.is_selected
                  }"
                  (click)="selectGroup(ind, group.group_id)"
                >
                  <span class="image is-32x32 mar-0-10">
                    @if (!group.group_icon) {
                    <empty-uname
                      [userName]="group.group_name"
                      [detailHeadProfile]="true"
                    ></empty-uname>
                    } @if (group.group_icon) {
                    <img [src]="profileUrl + group.group_icon" />
                    }
                  </span>
                  {{ group.group_name }}
                  @if (group.is_selected) {
                  <span class="icon is-small icon-align is-pulled-right">
                    <i class="fa fa-check"></i>
                  </span>
                  }
                </label>
                }

                <pagination-loader
                  [showFetchLoader]="showPaginateSpinner"
                ></pagination-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-card-foot">
      <div class="column">
        <button type="button" class="button" (click)="clearGroupSection()">
          Clear
        </button>
      </div>

      <div class="column has-text-right">
        <button
          type="button"
          class="button is-right"
          (click)="cancelGroupSection()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="button is-link is-right"
          (click)="addGroupSection()"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
